import { File } from "@prisma/client";
import { IKImage, IKImageProps } from "imagekitio-react";

export interface ImageComponentOwnProps extends Omit<IKImageProps, "path"> {
  image: File;
  imageClassName?: string;
  showCopyright?: boolean;
}

export function ImageComponent({
  image,
  imageClassName,
  className,
  showCopyright = true,
  ...props
}: ImageComponentOwnProps) {
  return (
    <div
      className={`${className} group flex flex-col flex-grow-0 flex-shrink-0`}
    >
      <IKImage
        path={image.url}
        alt={image.alt}
        className={imageClassName}
        {...props}
      />
      {showCopyright && (
        <div className="text-gray-500 group-hover:text-gray-700 text-xs p-1">
          {"© "}
          {image.copyright}
        </div>
      )}
    </div>
  );
}
